"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Mui_1 = require("../../Mui");
/**
 * WCAG 2.1 compliant Text component.
 * ---
 *
 * In order to meet WCAG 2.1 accessibility guidelines, this component
 * is always a `p` element.
 *
 * You can choose a number of variants, to achieve your designer's style.
 *
 * See: https://www.notion.so/BP-Title-and-Text-Document-Hierarchy-5931375db62f464a8169de791f82c9da
 */
function Text(props) {
    const { bold, sx, ...otherProps } = props;
    return ((0, jsx_runtime_1.jsx)(material_1.Typography, { ...otherProps, component: "p", sx: (0, Mui_1.mergeSxProps)({
            fontWeight: (theme) => (bold ? theme.typography.fontWeightBold : undefined),
        }, sx) }));
}
exports.Text = Text;
//# sourceMappingURL=Text.js.map